<template>
  <div class="page-account-setting">
    <bCardHeader :param="param"></bCardHeader>
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="page-setting" page_id="page_setting">
          <el-form
            ref="form"
            :model="form"
            :label-position="labelPosition"
            label-width="80"
          >
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('setting.phoneNum')">
                  <el-input
                    class="phone-input-left"
                    :disabled="true"
                    :value="`+${areaCode1}`"
                  ></el-input>
                  <!-- <el-input :class="(areaCode1 == '+86' && showButton)?'phone-input-right-part' : 'phone-input-right-full' "
                            :disabled="true"
                            :value="phoneNum"></el-input> -->
                  <el-input
                    class="phone-input-right-part"
                    :disabled="true"
                    :value="phoneNum"
                  ></el-input>
                  <el-button
                    v-if="showButton"
                    test_id="button_change_phonenumber"
                    class="password-right"
                    type="primary"
                    @click="changeEmail('changePhoneNum')"
                    >{{ $t("setting.change") }}</el-button
                  >
                </el-form-item>
                <el-form-item :label="$t('setting.email')">
                  <!-- <el-input :disabled="true"
                              class="phone-input-right-full"
                              :value="form.email"></el-input> -->
                  <el-input :disabled="true" :value="form.email"></el-input>
                  <!-- <el-input :disabled="true"
                            :class="{'password-left': showButton}"
                            :value="form.email"></el-input> -->
                  <!-- <el-button class="password-right"
                             test_id="button_change_email"
                             type="primary"
                             v-if="showButton"
                             @click="changeEmail('changeEmailAdd')">{{$t('setting.replace')}}</el-button> -->
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <!-- <el-form-item :label="$t('setting.password')">
                  <el-input class="password-left"
                            :disabled="true"
                            value="******"></el-input>
                  <el-button class="password-right"
                             test_id="button_change_password"
                             type="primary"
                             @click="changePassword">{{$t('setting.reset')}}</el-button>
                </el-form-item> -->
                <el-form-item :label="$t('setting.address')">
                  <el-input
                    :disabled="true"
                    class="address-input"
                    :value="form.address ? form.address : '--'"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('setting.language')">
                  <el-select
                    v-model="lang"
                    class="input-language"
                    test_id="select_language"
                    @change="onCommandLang(lang)"
                    placeholder="选择语言"
                  >
                    <el-option
                      :label="value.title"
                      v-for="(value, index) in langIndexOpt"
                      :key="index"
                      :value="value.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!--  -->
          </el-form>
        </div>
      </el-col>
    </el-row>

    <el-form :label-position="labelPosition" class="trade-account page-setting">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-for="(item,index) in tradeAccountList" :key="index">
          <el-form-item
            :label="$t(`tradeAccountType.${item.tradeAccountType}`)"
            v-show="item.tradeAccountNumber"
          >
            <el-input
              :class="item.tradeAccountType === 'MT5'?'password-left':''"
              v-model="item.tradeAccountNumber"
              :disabled="true"
            ></el-input>
            <el-button
              class="password-right"
              type="primary"
              v-if="item.tradeAccountType === 'MT5'"
              @click="changePasswordMt5"
              >{{ $t("setting.editPassword") }}</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!--重置密码弹窗组件-->
    <bDialog
      :dialogVisible.sync="emailIsCodeShow"
      class="change-email-dialog"
      :params="userInfoParams"
      :component="componentDialog"
    ></bDialog>
    <!-- <bDialog :dialogVisible.sync="phoneIsCodeShow"
             :params="getChangePhoneParams"
              refName='editAccountPassword'
             :component="changePhone"
             ></bDialog> -->
    <passwordDialog ref="password" id="passwordDialog"></passwordDialog>
    <bDialog
      :dialogVisible.sync="IsCodeShow"
      :params="accountParams"
      ref="codeDialog"
      refName="editAccountPassword"
      :component="editAccountPassword"
    ></bDialog>
    <!--mt5修改密码-->
    <!-- <bDialog :dialogVisible.sync="changePasswordMt5Show"
              :closeModal="closeModal"
              :params="getMt5Account"
              :component="passwordMt5"
              :showClose="false"></bDialog> -->
    <passwordMt5
      :params="getMt5Account"
      :visible.sync="changePasswordMt5Show"
    ></passwordMt5>
  </div>
</template>

<script>
// import Vue from 'vue'
// import changeEmail from './change-email.vue'
import changeUserInfo from './changeUserInfo.vue'
import { mapGetters, mapState } from 'vuex'
import passwordDialog from './password'
import changePhone from './changePhone'
import passwordMt5 from './pwdMt5'
import passwordPM from './passwordPM'

import editAccountPassword from './editAccountPassword'
import CountryCodes from 'country-code-info'
export default {
  name: 'account_setting',
  data() {
    return {
      buttons: [],
      componentDialog: changeUserInfo,
      IsCodeShow: false,
      phoneIsCodeShow: false,
      emailIsCodeShow: false,
      updateType: '', // 更改手机号还是邮箱
      param: {
        title: 'setting',
        links: [
          { title: 'home' },
          { title: 'my_account' },
          { title: 'setting' }
        ]
      },
      labelPosition: 'top',
      earaNum: '+86',
      address: '广东省深圳市南山区高新科技产业园',
      langIndexOpt: [
        { title: '简体中文', value: 'cn' },
        { title: '繁體中文', value: 'hk' },
        { title: 'English', value: 'en' }
      ],
      lang: '',
      areaCode: ['+86', '+852', '+886', '+00'],
      closeModal: false,
      orderId: '',
      changePhone: changePhone, // 修改电话号码弹窗内容
      changePasswordMt5Show: false,
      resetPwdPMShow: false,
      passwordMt5: passwordMt5,
      passwordPM: passwordPM,
      editAccountPassword: editAccountPassword,
      accountParams: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectLang',
      'getClientProfile',
      'getAccountInfo',
      'getUsertInfo'
    ]),
    ...mapState(['accountInfo', 'userInfo', 'filterSPTradingAccountList']),
    tradeAccountList() {
      let arr = []
      // SP 隐藏期货账户
    if (this.userInfo.isSPAccount === 'Y') {
      arr = this.filterSPTradingAccountList || []
    } else {
      arr = this.accountInfo || []
    }
      return arr.map(item => {
        item._tradeAccountType = item.tradeAccountType
          .toLowerCase()
          .replace(/_[a-z]/g, function(m) {
            return m.slice(1).toUpperCase()
          })
        return item
      })
    },
    getChangePhoneParams() {
      let phoneNum = this.phoneNum
      return {
        changePhoneNum: phoneNum,
        changePhoneNumShow: this.areaCode1 + this.phoneNum
        // changePhoneNumShow: this.form.phone
      }
    },
    getSecuritiesCashAccount() {
      let item = this.tradeAccountList.find(
        item => item._tradeAccountType === 'securitiesCash'
      )
      if (!item) return {}
      return item
    },
    getSecuritiesMarginAccount() {
      let item = this.tradeAccountList.find(
        item => item._tradeAccountType === 'securitiesMargin'
      )
      if (!item) return {}
      return item
    },
    getFuturesMarginAccount() {
      let item = this.tradeAccountList.find(
        item => item._tradeAccountType === 'futuresMargin'
      )
      if (!item) return {}
      return item
    },
    getFuturesDayTradingMarginAccount() {
      let item = this.tradeAccountList.find(
        item =>
          item._tradeAccountType === 'futuresDayTradingMargin' ||
          item._tradeAccountType === 'futuresDaytradingMargin'
      )
      if (!item) return {}
      return item
    },
    getMt5Account() {
      let item = this.tradeAccountList.find(
        item => item._tradeAccountType === 'mt5'
      )
      if (!item) return {}
      return Object.assign(item, {
        changePhoneNum: this.phoneNum,
        areaCode: this.areaCode1,
        changePhoneNumShow: this.areaCode1 + this.phoneNum,
        language:
          this.getClientProfile.userInfo.countryIssue === 'CHN' ? 'cn' : 'hk',
        email: this.form.email
      })
    },

    userInfoParams() {
      return {
        updateType: this.updateType,
        email: this.form.email,
        changePhoneNum: this.phoneNum,
        changePhoneNumShow: this.areaCode1 + this.phoneNum,
        areaCode: this.areaCode1
      }
    },
    form() {
      return this.getClientProfile.userInfo
    },
    areaCode1() {
      if (this.form.issuingCountry) {
        let countryDetail =
          CountryCodes.findCountry({ a3: this.form.issuingCountry }) || {}
        return countryDetail.dial || ''
      }
      return ''
      // return '+' + (this.form.phone.substring(0, 2) == 86 ? this.form.phone.substring(0, 2) : this.form.phone.substring(0, 3))
    },
    phoneNum() {
      return this.form.mobile
      // return this.form.phone.substring(0, 2) == 86 ? this.form.phone.substring(2) : this.form.phone.substring(3)
    },
    // tradeAccountShow () {
    //   return this.getChangePasswordMt5Params.tradeAccount
    // },
    showButton() {
      if (this.getUsertInfo.isAccountOpening) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    selectLang: {
      handler(val) {
        if (val) {
          console.log(val)
          this.lang = val
        }
      }
    }
  },
  mounted() {
    this.lang = sessionStorage.getItem('language')
      ? sessionStorage.getItem('language')
      : 'cn'
  },
  methods: {
    getLanguage() {
      let languageM = sessionStorage.getItem('language') || 'cn'
      let curLang = ''
      switch (languageM) {
        case 'en':
          curLang = 'en'
          break
        case 'zh-hant':
          curLang = 'hk'
          break
        case 'zh-hans':
          curLang = 'cn'
          break
        case 'cn':
          curLang = 'cn'
          break
        case 'hk':
          curLang = 'hk'
          break
        default:
          curLang = 'cn'
          break
      }
      return curLang
    },
    onSubmit() {
      console.log('submit!')
    },
    changePassword() {
      this.$refs.password.dialogFormVisible = true
    },
    changeEmail(type) {
      // TODO 打开页面，旧邮箱发送验证码，输入验证码，输入新邮箱，发送验证码，输入验证码，调用发送接口
      this.emailIsCodeShow = true
      this.updateType = type
    },
    onCommandLang(lang) {
      // Vue.setLanguage(lang)
      if (lang.charAt(0) === '/') this.onCommand(lang)
      sessionStorage.setItem('language', lang)
      this.$store.dispatch('selectLang', lang)
      this.$i18n.locale = sessionStorage.getItem('language')
      sessionStorage.setItem('isChange', 'yes')
      location.reload()
      // this.$store.commit("setCurLang", lang)
    },
    onCommand(path) {
      this.$router.push(path)
    },
    changePhoneNo() {
      this.phoneIsCodeShow = true
    },
    // refresh () {
    //   const oAuth = new SecurityService()
    //   oAuth.signOut()
    //   store.commit('setUser', null)
    // },
    changePasswordMt5() {
      this.changePasswordMt5Show = true
    },
    resetAccPwd(type) {
      this.IsCodeShow = true
      this.accountParams = this.getAccountParams(type)
    },
    getAccountParams(type) {
      let item = this.tradeAccountList.find(
        item => item._tradeAccountType === type
      )
      if (!item) return {}
      return {
        email: this.form.email,
        tradeAccount: item.tradeAccountNumber,
        tradeAccountType: item.tradeAccountType,
        language: this.lang,
        title: this.$t(`setting.editAccountPassword.${type}Title`)
      }
    },
    close(a, b) {
      console.log(a, b)
    }
  },
  components: { passwordDialog, passwordMt5, passwordPM }
}
</script>

<style lang="scss">
.page-setting {
  height: min-content;
}
.change-email-dialog {
  .el-dialog__header {
    display: none;
  }
}
.page-account-setting {
  .trade-account {
    padding: 1rem;
    margin-top: 1rem;
    background: white;
  }
  .trade-account-title {
    margin-bottom: 0px !important;
    .el-form-item__label {
      width: 200px !important;
      font-size: 20px !important;
      color: black !important;
    }
  }
  .page-setting {
    /* margin: 0.5rem; */
    padding: 1rem 1rem;
    background: white;
    .el-input__inner {
      height: 45px;
    }
  }
  .left-form,
  .right-form {
    display: inline-block;
    width: 45%;
    vertical-align: top;
  }
  .right-form {
    margin-top: 1rem;
    margin-left: 3rem;
  }
  .phone-input-left {
    width: 20%;
    margin-right: 2%;
  }
  .phone-input-right-full {
    width: 78%;
  }
  .phone-input-right-part {
    width: 48%;
  }
  .input-language {
    width: 100%;
  }
  .password-left {
    width: 70%;
  }
  .password-right {
    width: 25%;
    height: 45px;
    margin-left: 5%;
    font-family: Muli-Bold;
    font-size: 14px;
    color: #192b57;
    letter-spacing: 0.17px;
    text-align: center;
  }
  .el-form-item__label {
    font-family: Muli-Bold !important;
    font-size: 11px !important;
    color: #7d7d7d !important;
    letter-spacing: 0.13px !important;
  }
  .el-input__inner {
    font-family: PingFangSC-Semibold !important;
    font-size: 14px !important;
    color: #23282e !important;
    letter-spacing: 0 !important;
  }
  .phone-input-left .el-input_inner {
    font-family: Muli-Regular !important;
  }
  .input-language .el-input_inner {
    color: #24282d;
  }
  .address-input .el-input_inner {
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #23282e;
    letter-spacing: 0;
  }
  hr {
    margin-top: 0.5rem;
  }
  p {
    font-family: Muli-Regular;
    font-size: 16px;
    color: #7d7d7d;
    letter-spacing: 0.14px;
    line-height: 20px;
  }
  h2 {
    font-family: Muli-Bold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0.14px;
  }
  hr {
    border: 1px solid #f3f4f6;
  }
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding: 0;
    margin: 0;
  }
  .m-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .m15 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
</style>
